import img1 from "./images/The_Perfumist.jpg";
import img2 from "./images/Out_Of_Ashes.jpg";
import img3 from "./images/Swan_Light.jpeg";

export const books = [
  {
    img: img1,
    title: "The Perfumist of Paris",
    author: "Alka Joshi",
    id: 1,
  },

  {
    img: img2,
    title: "Out of the Ashes: A Novel",
    author: "Kara Thomas",
    id: 2,
  },
  {
    img: img3,
    title: "Swan Light: A Novel",
    author: " Phoebe Rowe",
    id: 3,
  },
];
